module.exports = __webpack_public_path__ + "static/media/cover-4.de60e1cc.jpg";